import { init as initApm } from '@elastic/apm-rum'

const apm = initApm({
  serviceName: 'bot-web',
  serverUrl: process.env.REACT_APP_APM_SERVER_URL,
  environment: process.env.REACT_APP_ENVIRONMENT,
  active: true,
  distributedTracing: true,
  serviceVersion: process.env.REACT_APP_VERSION,
})

export default apm
